import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../components/ui/Section';
import { useIsKenya, getPhoneDisplay } from '../hooks/useIsKenya';
function HeroArtwork() {
  return <motion.svg viewBox="0 0 400 300" className="w-full h-full max-h-[280px]" initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.8,
    delay: 0.2
  }} data-id="element-1337">
      {/* Large circle - stroke only */}
      <circle cx="200" cy="150" r="120" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.12" data-id="element-1338" />
      <circle cx="200" cy="150" r="80" fill="none" stroke="#00316B" strokeWidth="0.5" opacity="0.1" data-id="element-1339" />
      <circle cx="200" cy="150" r="40" fill="#00316B" opacity="0.04" data-id="element-1340" />

      {/* Arc segments */}
      <path d="M 80 150 A 120 120 0 0 1 200 30" fill="none" stroke="#00316B" strokeWidth="2" opacity="0.15" data-id="element-1341" />
      <path d="M 320 150 A 120 120 0 0 1 200 270" fill="none" stroke="#00316B" strokeWidth="2" opacity="0.15" data-id="element-1342" />

      {/* Grid lines */}
      <line x1="50" y1="150" x2="350" y2="150" stroke="#00316B" strokeWidth="0.5" opacity="0.08" data-id="element-1343" />
      <line x1="200" y1="20" x2="200" y2="280" stroke="#00316B" strokeWidth="0.5" opacity="0.08" data-id="element-1344" />

      {/* Diagonal lines */}
      <line x1="80" y1="50" x2="320" y2="250" stroke="#00316B" strokeWidth="0.5" opacity="0.06" data-id="element-1345" />
      <line x1="320" y1="50" x2="80" y2="250" stroke="#00316B" strokeWidth="0.5" opacity="0.06" data-id="element-1346" />

      {/* Scattered dots */}
      <circle cx="120" cy="80" r="3" fill="#00316B" opacity="0.18" data-id="element-1347" />
      <circle cx="280" cy="220" r="3" fill="#00316B" opacity="0.18" data-id="element-1348" />
      <circle cx="300" cy="80" r="2" fill="#00316B" opacity="0.12" data-id="element-1349" />
      <circle cx="100" cy="200" r="2" fill="#00316B" opacity="0.12" data-id="element-1350" />
      <circle cx="200" cy="150" r="4" fill="#00316B" opacity="0.2" data-id="element-1351" />

      {/* Small accent circles */}
      <circle cx="140" cy="120" r="15" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-1352" />
      <circle cx="260" cy="180" r="15" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-1353" />

      {/* Orange accent - subtle */}
      <circle cx="240" cy="100" r="6" fill="#FF6600" opacity="0.12" data-id="element-1354" />
    </motion.svg>;
}
function SidebarArtwork() {
  return <motion.svg viewBox="0 0 100 500" className="w-full h-auto" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.6,
    delay: 0.4
  }} data-id="element-1355">
      {/* Vertical line */}
      <line x1="50" y1="0" x2="50" y2="500" stroke="#00316B" strokeWidth="0.5" opacity="0.08" data-id="element-1356" />

      {/* Stacked circles */}
      <circle cx="50" cy="60" r="40" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-1357" />
      <circle cx="50" cy="60" r="25" fill="none" stroke="#00316B" strokeWidth="0.5" opacity="0.08" data-id="element-1358" />
      <circle cx="50" cy="60" r="4" fill="#00316B" opacity="0.15" data-id="element-1359" />

      <circle cx="50" cy="180" r="30" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-1360" />
      <circle cx="50" cy="180" r="15" fill="#00316B" opacity="0.04" data-id="element-1361" />

      <circle cx="50" cy="280" r="35" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-1362" />
      <circle cx="50" cy="280" r="20" fill="none" stroke="#00316B" strokeWidth="0.5" opacity="0.08" data-id="element-1363" />

      <circle cx="50" cy="380" r="25" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-1364" />
      <circle cx="50" cy="380" r="3" fill="#00316B" opacity="0.15" data-id="element-1365" />

      {/* Horizontal accent lines */}
      <line x1="20" y1="120" x2="80" y2="120" stroke="#00316B" strokeWidth="0.5" opacity="0.1" data-id="element-1366" />
      <line x1="30" y1="230" x2="70" y2="230" stroke="#00316B" strokeWidth="0.5" opacity="0.1" data-id="element-1367" />
      <line x1="25" y1="330" x2="75" y2="330" stroke="#00316B" strokeWidth="0.5" opacity="0.1" data-id="element-1368" />

      {/* Small dots */}
      <circle cx="30" cy="140" r="2" fill="#00316B" opacity="0.12" data-id="element-1369" />
      <circle cx="70" cy="260" r="2" fill="#00316B" opacity="0.12" data-id="element-1370" />
      <circle cx="35" cy="350" r="2" fill="#00316B" opacity="0.12" data-id="element-1371" />

      {/* Orange accent */}
      <circle cx="50" cy="450" r="20" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-1372" />
      <circle cx="50" cy="450" r="3" fill="#FF6600" opacity="0.15" data-id="element-1373" />
    </motion.svg>;
}
export function PrivacyPage() {
  const isKenya = useIsKenya();
  const phoneDisplay = getPhoneDisplay(isKenya);
  const sections = [{
    number: '1',
    title: 'Overview',
    content: <p data-id="element-1374">
          Belo Digital is committed to protecting personal data and privacy.
          This policy explains how we collect, use, and safeguard information.
        </p>
  }, {
    number: '2',
    title: 'Information We Collect',
    content: <>
          <p className="mb-6" data-id="element-1375">We may collect:</p>
          <div className="space-y-6" data-id="element-1376">
            <div data-id="element-1377">
              <h4 className="font-semibold text-[#0C0C0C] mb-3" data-id="element-1378">
                a) Personal Information
              </h4>
              <ul className="space-y-3" data-id="element-1379">
                {['Names', 'Email addresses', 'Phone numbers', 'Company details', 'Job or professional information'].map(item => <li key={item} className="flex items-start text-lg" data-id="element-1380">
                    <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2.5 mr-3 shrink-0" data-id="element-1381" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div data-id="element-1382">
              <h4 className="font-semibold text-[#0C0C0C] mb-3" data-id="element-1383">
                b) Technical Information
              </h4>
              <ul className="space-y-3" data-id="element-1384">
                {['IP addresses', 'Browser/device data', 'Usage analytics'].map(item => <li key={item} className="flex items-start text-lg" data-id="element-1385">
                      <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2.5 mr-3 shrink-0" data-id="element-1386" />
                      {item}
                    </li>)}
              </ul>
            </div>
            <div data-id="element-1387">
              <h4 className="font-semibold text-[#0C0C0C] mb-3" data-id="element-1388">
                c) Client & Business Data
              </h4>
              <p data-id="element-1389">Where relevant to services delivered under contract.</p>
            </div>
          </div>
        </>
  }, {
    number: '3',
    title: 'How We Use Information',
    content: <>
          <p className="mb-4" data-id="element-1390">We use data to:</p>
          <ul className="space-y-3" data-id="element-1391">
            {['Deliver and improve services', 'Communicate with clients & partners', 'Provide technical support', 'Meet legal or regulatory obligations', 'Enhance security and performance'].map(item => <li key={item} className="flex items-start text-lg" data-id="element-1392">
                <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2.5 mr-3 shrink-0" data-id="element-1393" />
                {item}
              </li>)}
          </ul>
        </>
  }, {
    number: '4',
    title: 'Data Protection & Security',
    content: <>
          <p className="mb-4" data-id="element-1394">
            We implement reasonable technical and organizational safeguards to
            protect data against:
          </p>
          <ul className="space-y-3" data-id="element-1395">
            {['Unauthorized access', 'Loss or misuse', 'Alteration or disclosure'].map(item => <li key={item} className="flex items-start text-lg" data-id="element-1396">
                <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2.5 mr-3 shrink-0" data-id="element-1397" />
                {item}
              </li>)}
          </ul>
        </>
  }, {
    number: '5',
    title: 'Data Sharing',
    content: <>
          <p className="mb-4" data-id="element-1398">
            We do not sell personal data. Information may only be shared:
          </p>
          <ul className="space-y-3" data-id="element-1399">
            {['With authorized service providers', 'Where legally required', 'Under contractual obligations'].map(item => <li key={item} className="flex items-start text-lg" data-id="element-1400">
                <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2.5 mr-3 shrink-0" data-id="element-1401" />
                {item}
              </li>)}
          </ul>
        </>
  }, {
    number: '6',
    title: 'Data Retention',
    content: <p data-id="element-1402">
          We retain data only as long as necessary for legitimate business,
          contractual, or legal purposes.
        </p>
  }, {
    number: '7',
    title: 'User Rights',
    content: <>
          <p className="mb-4" data-id="element-1403">
            Subject to applicable law, individuals may request:
          </p>
          <ul className="space-y-3" data-id="element-1404">
            {['Access to their data', 'Correction of inaccuracies', 'Deletion where appropriate', 'Withdrawal of consent (where applicable)'].map(item => <li key={item} className="flex items-start text-lg" data-id="element-1405">
                <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2.5 mr-3 shrink-0" data-id="element-1406" />
                {item}
              </li>)}
          </ul>
        </>
  }, {
    number: '8',
    title: 'Cookies & Tracking',
    content: <p data-id="element-1407">
          Our website may use cookies or analytics tools to improve user
          experience and performance.
        </p>
  }, {
    number: '9',
    title: 'Third-Party Links',
    content: <p data-id="element-1408">
          Our website may contain external links. We are not responsible for
          third-party privacy practices.
        </p>
  }, {
    number: '10',
    title: 'Policy Updates',
    content: <p data-id="element-1409">
          We may revise this Privacy Policy periodically. Updates will be
          reflected with a new effective date.
        </p>
  }, {
    number: '11',
    title: 'Contact Information',
    content: <div className="space-y-2" data-id="element-1410">
          <p data-id="element-1411">For privacy-related inquiries:</p>
          <p className="font-semibold text-[#0C0C0C]" data-id="element-1412">Belo Digital</p>
          <p data-id="element-1413">
            Email:{' '}
            <a href="mailto:biz@belo.co.ke" className="text-[#00316B] hover:text-[#FF6600] transition-colors" data-id="element-1414">
              biz@belo.co.ke
            </a>
          </p>
          <p data-id="element-1415">
            Phone:{' '}
            <a href="tel:+254701660306" className="text-[#00316B] hover:text-[#FF6600] transition-colors" data-id="element-1416">
              {phoneDisplay}
            </a>
          </p>
        </div>
  }];
  return <main className="pt-24" data-id="element-1417">
      <Section background="default" data-id="element-1418">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1419">
          <div data-id="element-1420">
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-sm font-semibold text-[#00316B] uppercase tracking-wider mb-4" data-id="element-1421">
              Legal
            </motion.p>
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.05
          }} className="text-4xl md:text-5xl font-bold font-heading text-[#0C0C0C] mb-4 leading-tight" data-id="element-1422">
              Privacy Policy
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="text-gray-500 text-base" data-id="element-1423">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })}
            </motion.p>
          </div>
          <div className="hidden lg:flex items-center justify-center" data-id="element-1424">
            <HeroArtwork data-id="element-1425" />
          </div>
        </div>
      </Section>

      <Section background="white" data-id="element-1426">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-1427">
          {/* Main content */}
          <div className="lg:col-span-9" data-id="element-1428">
            <div className="space-y-14" data-id="element-1429">
              {sections.map((section, index) => <motion.div key={section.number} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.04
            }} className="border-b border-gray-100 pb-14 last:border-0" data-id="element-1430">
                  <div className="flex items-start gap-4 mb-5" data-id="element-1431">
                    <span className="text-sm font-bold text-[#00316B] bg-[#00316B]/10 px-3 py-1.5 rounded mt-0.5 shrink-0" data-id="element-1432">
                      {section.number.padStart(2, '0')}
                    </span>
                    <h2 className="text-2xl font-bold font-heading text-[#0C0C0C]" data-id="element-1433">
                      {section.title}
                    </h2>
                  </div>
                  <div className="ml-14 text-gray-600 leading-relaxed text-lg" data-id="element-1434">
                    {section.content}
                  </div>
                </motion.div>)}
            </div>
          </div>

          {/* Decorative sidebar */}
          <div className="hidden lg:block lg:col-span-3" data-id="element-1435">
            <div className="sticky top-32" data-id="element-1436">
              <SidebarArtwork data-id="element-1437" />
            </div>
          </div>
        </div>
      </Section>
    </main>;
}